import { findDynamicPathAccess } from "./findDynamicPathAccess";
import { DynamicPathAccess, PermissionKey } from "./types";

const pathPermissionKeyMap: Record<string, PermissionKey> = {
  "/assets/accounts": "accounts",
  "/assets/locations": "locations",
  "/assets/countries": "locations",
  "/assets/rooms": "rooms",
  "/assets/devices": "devices",
  "/meetings": "meetings",
  "/tickets": "tickets",
  "/configuration": "globalConfiguration",
};

const generalPathPermissions: DynamicPathAccess[] = [
  {
    pathRegex: /^\/assets\/accounts\/[^/]+$/,
    permissionKey: "accounts",
  },
  {
    pathRegex: /^\/assets\/accounts\/.*\/configuration\/.*$/,
    permissionKey: "accountConfiguration",
  },
  {
    pathRegex: /^\/assets\/locations\/.*/,
    permissionKey: "locations",
  },
  {
    pathRegex: /^\/assets\/rooms\/.*/,
    permissionKey: "rooms",
  },
  {
    pathRegex: /^\/assets\/devices\/.*/,
    permissionKey: "devices",
  },
  {
    pathRegex: /^\/tickets\/.*/,
    permissionKey: "tickets",
  },
  {
    pathRegex: /^\/meetings\/.*/,
    permissionKey: "meetings",
  },
  {
    pathRegex: /^\/bi\/reports.*/,
    permissionKey: "reports",
  },
  {
    pathRegex: /^\/bi\/analytics.*/,
    permissionKey: "analyticsReports",
  },
];

export const getPathPermissionKey = (path: Location["pathname"]) => {
  return (
    pathPermissionKeyMap[path] ??
    findDynamicPathAccess(path, generalPathPermissions, "permissionKey")
  );
};
